import { render } from "./allExpenseList.vue?vue&type=template&id=65164036"
import script from "./allExpenseList.vue?vue&type=script&lang=js"
export * from "./allExpenseList.vue?vue&type=script&lang=js"

import "./allExpenseList.vue?vue&type=style&index=0&id=65164036&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__